import { useMutation } from '@tanstack/react-query'

import api from '@/lib/api'
import { useAccessToken, useCurrentUser } from '@/features/auth/state/auth'
import { extractApiErrorMessage, type DownloadFileResult, toDownloadFileResult } from './download-utils'

export interface LimparXmlPrevidenciarioRequest {
  file: File
  removerIdEvento?: boolean
}

export function useLimparXmlPrevidenciario() {
  const token = useAccessToken()
  const user = useCurrentUser()

  return useMutation({
    mutationFn: async ({
      file,
      removerIdEvento
    }: LimparXmlPrevidenciarioRequest): Promise<DownloadFileResult> => {
      if (!file) {
        throw new Error('Arquivo é obrigatório')
      }

      if (!user || !token) {
        throw new Error('Usuário não autenticado')
      }

      const formData = new FormData()
      formData.append('file', file)
      if (typeof removerIdEvento === 'boolean') {
        formData.append('remover_id_evento', String(removerIdEvento))
      }

      try {
        const response = await api.post<Blob>('/previdenciario/limpar_xml', formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          },
          responseType: 'blob'
        })

        if (!response.data) {
          throw new Error('Erro ao limpar XML previdenciário')
        }

        return toDownloadFileResult(response, 'xml-limpos.zip')
      } catch (error) {
        throw new Error(await extractApiErrorMessage(error, 'Erro ao limpar XML previdenciário'))
      }
    }
  })
}
